module.exports = __webpack_public_path__ + "media/images/post/icon_update-d6105d8168592147c0b07056dc467968.png";